import { MonoBehavior } from './core/monoBehavior';
import { Container, FederatedPointerEvent, Graphics, Point } from 'pixi.js';
import { Card } from 'components/Card';
import { CardPlace, GamePlace } from 'constants/cards';
import { SolitaireGame } from './SolitaireGame';
import { Layout } from './LayoutManager';
import { MOVE_Z_INDEX } from 'constants/layout';

export type Move = {
    list: string[];
    from: CardPlace;
    cardToActivate?: Card;
    cardToHide?: Card;
    target: GamePlace;
};
export class StockpileButton extends MonoBehavior {
    deckButton: Container;
    disabled = false;
    block = true;
    game: SolitaireGame;

    constructor(parent: SolitaireGame) {
        super();
        this.onClick = this.onClick.bind(this);
        this.game = parent;

        this.deckButton = new Container();
        const buttonFill = new Graphics();
        buttonFill.rect(0, 0, 100, 100);
        buttonFill.fill(0xffffff);
        this.deckButton.alpha = 0.00001;
        this.deckButton.addChild(buttonFill);

        parent.gameContainer.addChild(this.deckButton);
        this.deckButton.eventMode = 'static';
        this.deckButton.on('pointerdown', this.onClick);
        this.deckButton.zIndex = MOVE_Z_INDEX + 1000;
    }
    onClick(e: FederatedPointerEvent) {
        e.stopPropagation();
        if (this.block) return;

        this.game.stockPile.deal();
    }

    drawDeckButton(position: Point) {
        const { width, height } = Layout.getCardSize();
        this.deckButton.position = position;
        const button = this.deckButton.children[0];
        button.position.set(-width / 2, -height / 2);
        button.width = width;
        button.height = height;
    }
    destroy(): void {
        super.destroy();
        this.deckButton.removeFromParent();
        this.deckButton.removeAllListeners();
        this.deckButton.removeChildren();
    }
}
